module.exports = __webpack_public_path__ + "static/img/img-3-6.3b4d4ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-6.png
// module id = Qh8z
// module chunks = 0